import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
    AuthenticationDetails,
    useCurrentUserSelector,
} from 'store/features/authentication';

export const useAuth = () => {
    const authentication: AuthenticationDetails = useSelector(
        useCurrentUserSelector
    );

    return useMemo(() => authentication, [authentication]);
};
